<template>
	<div>
		<div class="headView">
			<div class="headView_top">
				<p class="applyTitle">项目名称：{{project.project_name}}</p>
			</div>
			<div class="headClass">
				<p>项目类型：{{project.project_type_name}}</p>
				<p>申请时间：{{project.apply_start}}-{{project.apply_end}}</p>
				<!--<p>审核时间：{{project.app_start}}-{{project.app_end}}</p>-->
			</div>
		</div>
		<!-- 申报审核通用封装组件 -->
		<div class="content_view">
			<div class="contentLeft">
				<p v-for="(item,index) in navList" v-show="navList[index]" :key="index" @click="changeTab(index)"
					:class="navIndex === index?'tabActive':''">
					{{item}}
				</p>
			</div>
			<div class="contentRight">
				<div v-show="navIndex == 0">
					<p class="view_head">
						基本信息
					</p>
					<div v-if="this.project.project_type === '10'">
						<zjManagerView :datas="allList"></zjManagerView>
					</div>
				</div>
				<div class="" v-show="navIndex == 1">
					<!-- 浙江优秀项目经理 -->
					<p class="view_head">获奖信息</p>
					<div class="qc_clumView" v-for="(item,index) in award" :key="index">
						<div class="inner_title">
							<p>{{item.project_name}}</p>
							{{item.number}}
							<p>项:</p>
						</div>
						<div class="qc_clumView_right">
							{{item.award_name}}
						</div>
					</div>
				</div>
				<div class="uploadContent" v-show="navIndex == 2">
					<p class="view_head">资料上传</p>
					<div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
						<div class="uploadList_head">
							<p>{{item}}</p>
						</div>
						<div class="uploadList_mid">
							<p>{{uploadData.tips[index]}}</p>
						</div>
						<div class="uploadList_bot">
							<div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
								@click="navTo(item)">
								<p>{{item.data_name?item.data_name:item.name}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getApplicationDetail
	} from '../../api/moudles/management.js'
	import {
		getDataItem,
	} from '../../api/moudles/manager.js'
	import {
		API_DOMAIN
	} from '../../api/api.js'
	
	import zjManagerView from './components/zjManagerView.vue'

	export default {
		data() {
			return {
				awardWidth: '1060px',
				project_code: '',
				project_app_num: '',
				allList: '',
				id: '',
				project: '',
				award: '',
				navIndex: 0,
				navList: [
					/*"申报须知",
					"评选办法",*/
					"基本信息",
					"获奖信息",
					"资料上传"
				],
				// 资料上传内容
				uploadData: '',
				// 上传文件列表
				uploadList: [],
			}
		},
		components: {
			zjManagerView
		},
		created() {
			if (!this.$route.params.id) {
				this.$router.go(-1)
				return
			}
			this.id = this.$route.params.id
			this.getApplicationDetail()
		},
		mounted() {
			const that = this;
			window.onresize = () => (() => {
				const screenWidth = document.body.clientWidth;
				// 500以下第一次
				// console.log('size', screenWidth)
				// <1500的时候需要动态改变
				if (screenWidth < 1500 && screenWidth > 960) {
					let supWidth = 1500 - screenWidth
					that.awardWidth = 1060 - supWidth + 'px'
				}
				if (screenWidth < 961) {
					that.awardWidth = '520px'
				}
			})();
		},
		methods: {
			navTo(item) {
				let newUrl = item.stored_path ? item.stored_path : item.url
				window.open(newUrl)
			},
			// 获取目录
			async getProjectList(type) {
				await getDataItem({
					data: {
						type
					},
					success: res => {
						// console.log('上传资料详情', res)
						this.uploadData = res.data
					}
				})
			},
			// 切换tab栏/
			changeTab(index) {
				this.navIndex = index
			},
			// 获取详情
			async getApplicationDetail() {
				await getApplicationDetail({
					data: {
						id: this.id
					},
					success: res => {
						// console.log('res', res)
						this.project_code = res.data.project.project_code
						this.project_app_num = res.data.basicMsg.project_application_id
						const uploadList = res.data.datas
						let newUploadList = []
						uploadList.forEach((item, index) => {
							newUploadList[Number(item.type) - 1] = []
						})
						uploadList.forEach((item, index) => {
							newUploadList[Number(item.type) - 1].push(item)
						})
						this.uploadList = newUploadList
						// 工程信息
						this.project = res.data.project
						// 获奖信息
						this.award = res.data.award
						// 基本信息
						this.allList = res.data.basicMsg
						this.getProjectList(this.project.project_type)
					}
				})
			},
		}
	}
</script>

<style scoped>
	/* 每个上传文件的样式 */
	.inner_upload {
		position: relative;
		min-height: 40px;
		margin: 0 10px;
		/* width: 100px; */
		/* overflow: scroll; */
	}

	.inner_upload p {
		color: #1890FF;
	}

	.inner_upload img {
		border-radius: 50%;
		position: absolute;
		right: 0;
		top: 0;
		width: 15px;
		height: 15px;
		cursor: pointer;
	}

	.newTab {
		margin: 20px;
	}

	/* 上传样式 */
	.uploadBtn {
		margin-top: 60px;
		margin-bottom: 60px;
		display: flex;
		margin-left: 41.5%;
	}

	.uploadBtn button {
		width: 140px;
	}

	.uploadHead {
		display: flex;
		position: absolute;
		align-items: center;
		left: 255px;
	}

	.uploadHead p {
		margin-left: 10px;
		color: #1890FF;
		cursor: pointer;
	}

	.uploadList {
		border: 1px solid #f0f0f0;
		width: 90%;
		margin-top: 30px;
		margin-left: 5%;
	}

	.uploadList_head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 0 40px 0 10px;
		line-height: 40px;
		font-size: 14px;
		flex-wrap: wrap;
		border-bottom: 1px solid #f0f0f0;
	}

	.head_list {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.head_list p {
		margin-left: 10px;
	}

	.head_list p:hover {
		color: #1890FF;
		text-decoration: underline;
	}

	.uploadList_mid {
		width: 90%;
		min-height: 30px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}

	.uploadList_mid p {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 24px;
		text-align: left;
		text-indent: 2em;
		padding: 10px;
	}

	.uploadList_bot {
		width: 70%;
		min-height: 30px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}

	.uploadList_bot p {
		display: inline-block;
		height: 40px;
		line-height: 40px;
		color: #1890FF;
		text-decoration: underline;
		margin: 0 20px;
		cursor: pointer;
	}

	/* 上传样式 */
	.uploadContent {
		padding-bottom: 60px;
	}

	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.titleLeft {
		margin-left: 50px;
	}

	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.midflex {
		display: flex;
		width: 90%;
		height: 50px;
		margin-left: 5%;
		align-items: center;
		justify-content: center;
		border-top: 1px solid #eee;
	}

	.newAddBtn {
		width: 100%;
		display: flex;
		height: 70px;
		align-items: center;
		justify-content: center;
	}

	.headView {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
	}

	.headView_top {
		width: 1350px;
		display: flex;
		justify-content: space-between;
	}

	.headView_top button {
		width: 100px;
		height: 35px;
		background-color: #1890FF;
		color: white;
		line-height: 35px;
		cursor: pointer;
	}

	.applyTitle {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.headClass {
		display: flex;
		margin-top: 10px;
	}

	.headClass p {
		margin-right: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	/* 申报 */
	.content_view {
		margin-top: 20px;
		max-width: 1350px;
		min-height: 350px;
		display: flex;
		border: 1px solid #f0f0f0;
	}

	.contentLeft {
		width: 200px;
	}

	.contentLeft p {
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		color: #333333;
		background-color: #fafafa;
		cursor: pointer;
	}

	.contentRight {
		width: 100%;
	}

	.tabActive {
		background: #e6f7ff !important;
		color: #6ea7ff !important;
		border-right: 2px solid #0077ff;
	}

	.content_btn {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
		margin-bottom: 30px;
	}

	.content_btn p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FE2C54;
	}

	.content_btn button {
		width: 150px;
		margin-top: 40px;
		margin-left: 440px;
	}

	.specialView {
		width: 720px;
		display: flex;
		align-items: center;
	}

	.specialView input {
		margin-left: 20px;
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		letter-spacing: 1px;
		border-bottom: 1px solid #DBDBDB;
	}

	.specialView input::placeholder {
		color: #B5B5B5;
	}

	.qc_clumView p {
		text-align: left;
		font-size: 14px;
		display: inline-block;
		margin-bottom: 10px;
	}

	.qc_clumView_right {
		min-height: 100px;
		border: 1px solid #eee;
		box-sizing: border-box;
		border-radius: 10px;
		width: calc(100% - 70px);
		text-align: left;
		padding: 20px;
		font-size: 14px;
	}

	.qc_clumView {
		width: 100%;
		display: flex;
		flex-flow: column;
		margin: 10px;
		padding-left: 50px;
	}

	.inner_title {
		text-align: left;
	}
</style>
